import React from 'react'

import { Icon } from 'loyal-react'
import PropTypes from 'prop-types'
import { numberToStrCurrency } from 'Shared/CurrencyLabel/CurrencyLabel'

const Option = ({ value, selected, handleOnClick, index, pointsName, selectedDiscount }) => {
  const isError = selectedDiscount.id === value.id ? selectedDiscount.isError : false
  const id = `option_${value.selectedID}_credits`
  const borderActive = selected ? isError ? 'border-color-error' : 'border-color-brand-1' : 'border-color-ui-2'
  const colorActive = selected ? isError ? 'color-error' : 'color-brand-1' : 'color-icon-accessibility'

  return (
    <a
      id={`filter-${index}`}
      name={id}
      href='javascript:void(0)'
      role='checkbox'
      aria-checked={selected}
      onClick={() => handleOnClick(value.id, value)}
      className='col-12 col-md-6 p-0 p-1'
      aria-label={`${value.points} pontos iupp valem: R$ ${numberToStrCurrency(value.credit, 2)} em crédito`}
    >
      <div className={`col-12 d-flex align-items-center border ${borderActive} px-2 py-3 radius mb-1`}>
        <Icon className={`${colorActive} icon icon_convert mr-2`} />
        <div className='d-flex flex-column'>
          <p aria-hidden>
            <small>{value.points} {pointsName} iupp valem:</small>
            {selected}
          </p>
          <h4 aria-hidden>
            <strong className={`fontSize20 ${isError && colorActive}`}>R$ {numberToStrCurrency(value.credit, 2)} em crédito</strong>
          </h4>
        </div>
      </div>
      {isError && (
        <span role='alert' className={colorActive}>Você não tem pontos suficientes</span>
      )}
    </a>
  )
}
Option.propTypes = {
  value: PropTypes.object.isRequired,
  selected: PropTypes.string.isRequired,
  handleOnClick: PropTypes.func.isRequired,
  selectedDiscount: PropTypes.object,
  index: PropTypes.number,
  pointsName: PropTypes.string
}

export default function OptionsContainer ({ selectedDiscount, conversionValues, selectedID, handleSelectInvoice, pointsName }) {
  return (
    <div className='col-md col-12 border border-color-ui-2 radius bg-white mt-4 mr-md-3 p-0'>
      <div className='points-cash-background p-2 d-flex align-items-center'>
        <h1 className='fontSize30 col-7 col-md-12'> </h1>
      </div>
      <div className='p-2'>
        <h1 className='my-2 fontSize20 p-1'>Selecione quantos créditos na fatura Itaucard você quer receber.</h1>

        <div className='d-flex flex-wrap border-bottom border-color-ui-4 pb-2'>
          {conversionValues.map((value, index) => (
            <Option
              value={value}
              selected={value.id === selectedID}
              handleOnClick={handleSelectInvoice}
              index={index}
              pointsName={pointsName}
              selectedDiscount={selectedDiscount || {}}
            />
          ))}
          <span className='p-1 color-ui-2 txt-font-body lineHeight19'>
            *Não é valido para cartões de parcerias, como: Credicard, Hipercard, Pão de Açúcar, Compre Bem, Extra, Passai, Sams, Walmart, Ipiranga, Magazine Luiza, Polishop, PontoFrio, Marisa, Business, Fiat, Ford, Volkswagen, Mitsubishi, Tim, Vivo, Livraria Cultura, N Card, Brastemp, Sulamerica, Tudo Azul, Latam.
          </span>
        </div>

        <div>
          <h2 className='my-2 p-1 fontSize20 '>Veja o que você precisa saber:</h2>
          <div className='col-12 d-flex flex-wrap p-0'>
            <div className='col-md-6 col-12 p-1'>
              <div
                className='h-100 col-12 py-1 d-flex align-items-center border border-color-ui-3 radius'
              >
                <Icon
                  aria-hidden
                  className='icon icon_card color-brand-1 mr-2'
                />
                <p>Troque seus pontos por crédito na fatura do seu cartão de crédito Itaucard.</p>
              </div>
            </div>
            <div className='col-md-6 col-12 p-1'>
              <div
                className='h-100 col-12 py-1 d-flex align-items-center border border-color-ui-3 radius'
              >
                <Icon aria-hidden className='icon icon_profile color-brand-1 mr-2' />
                <p>A troca de ponto por crédito em fatura está disponível apenas para clientes que possuem cartões Itaucard.</p>
              </div>
            </div>
          </div>
          <div className='col-12 d-flex flex-wrap p-0'>
            <div className='col-md-6 col-12 p-0 p-1'>
              <div
                className='h-100 col-12 py-1 d-flex align-items-center border border-color-ui-3 radius'
              >
                <Icon
                  aria-hidden
                  className='icon icon_cash color-brand-1 mr-2'
                />
                <p>O valor resgatado será creditado em seu cartão Itaucard ativo.</p>
              </div>
            </div>
            <div className='col-md-6 col-12 p-1'>
              <div
                className='h-100 col-12 py-1 d-flex align-items-center border border-color-ui-3 radius'
              >
                <Icon aria-hidden className='icon icon_calendar color-brand-1 mr-2' />
                <p>
                  O crédito resgatado estará disponível em sua próxima fatura em aberto, que pode ser visualizada em até 40 dias.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

OptionsContainer.propTypes = {
  conversionValues: PropTypes.array,
  selectedID: PropTypes.string,
  handleSelectInvoice: PropTypes.func,
  pointsName: PropTypes.string,
  selectedDiscount: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/features/InvoiceCredit/OptionsContainer.js